import { VueMaskDirective } from "v-mask";

export default VueMaskDirective;
